<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-3">
          <ul class="admin_sidebar">
            <li class="active">Пользователи <span @click="createUser"><i class="fas fa-plus-square"></i></span></li>
          </ul>
        </div>
        <div class="col-md-9">
          <div class="admin_item">
            <h3>Пользователи {{ getUsersList.length }}</h3>
            <div class="users_params">
              <div v-if="null" class="search_block">
                <input type="text">
                <span class="btn btn-primary"><i class="fas fa-search"></i></span>
              </div>
            </div>
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="user_assets">
                    <p>Почта</p>
                    <p>Имя</p>
                    <p>Телефон</p>
                    <p>Дата регистрации</p>
                  </div>
                  <div class="users_list">
                    <div class="user_item" v-for="item in getUsersList" :key="item.user.id">
                      <p>{{ item.user.email }}</p>
                      <p>{{ item.user.first_name }}</p>
                      <p>{{ item.user.phone || "Не указан" }}</p>
                      <p>{{ item.user.created_at }}</p>
                      <router-link class="edit" :to="{ name: 'UserEdit',  params: { id: item.user.id }}"><i
                          class="far fa-edit"></i></router-link>
                    </div>

                  </div>
                </div>
                <div v-if="null" class="col-3">
                  <div class="admin_sort">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="param1">
                      <label class="form-check-label" for="param1">
                        Параметр 1
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="param2">
                      <label class="form-check-label" for="param2">
                        Параметр 2
                      </label>
                    </div>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" value="" id="param3">
                      <label class="form-check-label" for="param3">
                        Параметр 3
                      </label>
                    </div>
                    <span class="btn btn-primary btn_sort">Применить</span>
                  </div>
                </div>
              </div>
              <div v-if="null" class="row">
                <div class="col-12">
                  <div class="pagination">
                    <ul>
                      <li class="active">1</li>
                      <li>2</li>
                      <li>3</li>
                      <li>4</li>
                      <li>5</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import vueTable from '../components/table/vue-table'
import revogridTable from '../components/table/revogrid-table'
import api from '../services/api'

export default {
  name: "Account",
  // eslint-disable-next-line vue/no-unused-components
  components: {'vue-table': vueTable, 'revogrid-table': revogridTable},
  methods: {
    ...mapActions([
      'getListUsers'
    ]),
    createUser() {
      this.$prompt(
          "Введите адрес электронной почты",
          "someone@example.com",
          "Создание пользователя",
          "question", {input: "email", confirmButtonText: "Продолжить", cancelButtonText: "Отмена"}
      )
          .then((email) => {
            this.$prompt(
                "Введите пароль",
                "",
                "Создание пользователя",
                "question",
                {
                  input: "password", inputValidator: (value) => {
                    if (value.length < 8) {
                      return "Пароль должен быть не менее 8 символов";
                    }
                  }, confirmButtonText: "Создать", cancelButtonText: "Отмена"
                }
            ).then((password) => {
              try {
                this.createUserRequest(email, password);
                this.getListUsers();
                this.$alert(
                    "Вы успешно создали пользователя с почтой " + email,
                    "Успех",
                    "success",
                    {
                      confirmButtonText: "OK",

                    }
                ).then(() => {
                  console.log(email, password);
                });
              } catch (e) {
                this.$alert(e.message, "Ошибка", "error");
              }

            }).catch(() => console.log("canceled"))
          })
          .catch(() => console.log("canceled"));
    },
    async createUserRequest(email, password) {
      const data = {
        email: email,
        password: password,
        first_name: email,
        created_at: this.$moment(new Date()).format(),
      };
      try {
        let response = await api.post('/auth/register', data);
        return response.data;
      } catch (error) {
        throw new Error({message: JSON.stringify(error.response.data)});
      }
    },

  },
  data: () => {
    return {}
  },
  computed: {
    ...mapGetters(['getUsersList',])
  },
  created() {
    this.getListUsers()
  },

  mounted() {

  },
}
</script>

<style scoped>
.admin_sidebar {
  padding: 10px 0;
  margin-top: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.admin_sidebar li {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  padding: 10px 20px;
  cursor: pointer;
  transition: all .2s ease;
}

.admin_sidebar li span {
  margin-left: 10px;
}

.admin_sidebar li span:hover {
  color: #0d6efd;
}

.admin_sidebar li:hover {
  background: #ededed;
}

.admin_item {
  padding: 20px;
  margin-top: 50px;
  border-radius: 10px;
  box-shadow: 0 2px 6px 0 rgb(32 33 37 / 10%);
  border: 1px solid #ddd;
}

.admin_item h3 {
  border-bottom: 1px dashed #ccc;
  color: #333;
  font-size: 24px;
  font-weight: 600;
}

.users_params {
  margin-bottom: 20px;
}

.users_params .search_block {
  display: flex;
  align-items: center;
}

.users_params .search_block input {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 5px 15px;
}

.users_params .search_block span {
  margin-left: 10px;
  border-radius: 10px;
}

.admin_sort {
  height: 100%;
  border-left: 1px dashed #ccc;
  padding: 10px;
}

.admin_sort .btn_sort {
  border-radius: 10px;
  margin-top: 10px;
}

.user_assets {
  display: flex;
  align-items: center;
  border-bottom: 1px dashed #ccc;
  margin-bottom: 20px;
  padding: 0 15px;
}

.user_assets p {
  width: 25%;
  text-align: left;
  font-size: 14px;
  color: #555;
}

.users_list {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.users_list .user_item {
  position: relative;
  padding: 10px;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  border-radius: 10px;
  transition: all .2s ease;
  cursor: pointer;
  padding-right: 35px;
  background: #f1f1f1;
  border: 1px solid transparent;
}

.users_list .user_item:hover {
  background: #ededed;
  border: 1px solid #d2d2d2;
}

.users_list .user_item p {
  color: #222;
  margin-bottom: 0;
  font-weight: 500;
  padding-left: 10px;
  padding-right: 5px;
  border-right: 1px solid #ccc;
  font-size: 14px;
  width: 25%;
  text-align: left;
}

.users_list .user_item .edit {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 14px;
  color: #333;
  transition: all 0.2s ease;
}

.users_list .user_item .edit:hover {
  color: #0d6efd;
}

.input_group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.input_block {
  width: 49%;
  margin: 10px 0;
  display: inline-block;
}

.input_block input {
  width: 100%;
  border-radius: 10px;
  border: 1px solid #ccc;
  outline: none;
  padding: 7px 10px;
  font-size: 14px;
}

.input_block p {
  margin-bottom: 5px;
}

.account .account_item span {
  width: 200px;
  border-radius: 10px;
  margin-top: 10px;
}

.pagination {
  display: flex;
  align-items: center;
  border-top: 1px dashed #ccc;
  padding: 20px 0;
  width: 100%;
}

.pagination ul {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.pagination ul li {
  width: 30px;
  height: 30px;
  border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  cursor: pointer;
  border-radius: 5px;
}

.pagination ul li.active {
  border: 1px solid #0d6efd;
  color: #0d6efd;
}
</style>
